import React, { useState, useEffect } from 'react';
import Note from './Note';
import './notes.css';
import { Pencil } from 'lucide-react';
import SocietyLayout from '../SocietyLayout';

function NoteApp() {
  const [notes, setNotes] = useState(() => {
    const savedNotes = localStorage.getItem('notes');
    return savedNotes ? JSON.parse(savedNotes) : [];
  });

  useEffect(() => {
    localStorage.setItem('notes', JSON.stringify(notes));
  }, [notes]);

  const addNote = () => {
    setNotes([...notes, {id: Date.now() ,text: '', html: '' }]);
  };

  const updateNote = (id, newNote) => {
    // const newNotes = notes.slice();
    // newNotes[index] = newNote;
    const newNotes = notes.map((note) => {
      return note.id === id ? { ...note, ...newNote } : note;
    });
    setNotes(newNotes);
  };

  const deleteNote = (id) => {
    const newNotes = notes.filter(note => note.id !== id);
    setNotes(newNotes);
  };

  const storedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem('user'));
    } catch {
      return null;
    }
  })();
  const userName = storedUser?.firstname || 'Your';

  return (
    <SocietyLayout>
      <div className='notes-page'>
        <h2 className='notes-subtitle'>These are {userName}'s notes</h2>
        <h1 className='notes-title'>Nottify - A Note Making App</h1>
        <button className="btn_add" onClick={addNote}>
          <Pencil size={16} /> Add Note
        </button>
        <div className="notes-container">
          {notes.map((note) => (
            <Note
              key={note.id}
              note={note}
              onDelete={() => deleteNote(note.id)}
              onUpdate={(newNote) => updateNote(note.id, newNote)}
            />
          ))}
        </div>
      </div>
    </SocietyLayout>
  );
}

export default NoteApp;
